<template>
    <div class="flex flex-col gap-1">
        <label class="font-medium text-primary dark:text-dark-50" :class="label_class">{{ label }}
            <span v-if="required" class="text-red-500">*</span>
        </label>
        <Textarea :id="id" :name="name" :placeholder="placeholder" :class="input_class" :value="modelValue"
            :disabled="disable_input" @input="$emit('update:modelValue', $event.target.value)" :invalid="!valid" :rows="rows" cols="30" />
        <Message v-if="!valid" severity="error" size="small" variant="simple">{{
            errorMessage }}</Message>
    </div>
</template>

<script>
import { Textarea, Message } from 'primevue';

export default {
    name: 'InputTextAreaCustom',
    props: {
        label: String,
        label_class: String,
        id: String,
        name: String,
        placeholder: String,
        input_class: String,
        modelValue: String,
        disable_input: Boolean,
        valid: Boolean,
        errorMessage: String,
        required: Boolean,
        rows: {
            type: Number,
            default: 3
        }
    },
    components: {
        Textarea, Message
    },
    emits: ['update:modelValue'],
}
</script>